<ng-template #tree let-items let-depth="depth">
  <ul class="nav-tree" [attr.data-depth]="depth">
    @for (item of items; track item.label) {
    <li class="nav-node">
      <button
        type="button"
        class="nav-link"
        [class.active]="item.isActive"
        [class.group]="!!item.children?.length"
        (click)="onNavItemClick(item)"
      >
        <span class="nav-link-copy">
          <span>{{ item.label }}</span>
          @if (item.description) {
          <small>{{ item.description }}</small>
          }
        </span>
      </button>
      @if (item.children?.length) {
      <ng-container
        [ngTemplateOutlet]="tree"
        [ngTemplateOutletContext]="{
          $implicit: item.children,
          depth: depth + 1
        }"
      ></ng-container>
      }
    </li>
    }
  </ul>
</ng-template>

@if (mode === 'docked') {
<otui-card class="nav-sidebar-card docked">
  <nav [attr.aria-label]="heading">
    <div class="nav-heading">{{ heading }}</div>
    <ng-container
      [ngTemplateOutlet]="tree"
      [ngTemplateOutletContext]="{ $implicit: navItems, depth: 0 }"
    ></ng-container>
  </nav>
</otui-card>
} @else {
<otui-modal
  [heading]="heading"
  (close)="onClose()"
  [position]="'sidebar-left'"
  [visible]="isOpen"
>
  <otui-card class="nav-sidebar-card">
    <nav [attr.aria-label]="heading">
      <ng-container
        [ngTemplateOutlet]="tree"
        [ngTemplateOutletContext]="{ $implicit: navItems, depth: 0 }"
      ></ng-container>
    </nav>
  </otui-card>
</otui-modal>
}
